export default __webpack_public_path__ + "KaTeX_Fraktur-Bold.069514d4061bbc045836eaec100359b9.ttf";